module.exports = __webpack_public_path__ + "static/media/back.c24d3d53.svg";